import { Box, IconButton, Theme } from '@mui/material';
import { SystemCssProperties } from '@mui/system';

import { gradients } from 'constants/gradients.constants';

import Icon from 'components/@icons/Icon';

import { CHEVRON_FONT_SIZE } from './constants';

interface Props {
  direction: 'left' | 'right';
  onClick: () => void;
  iconHeight: number;
  visibility: SystemCssProperties<Theme>['visibility'];
}

const DirectionStyles: Record<
  'left' | 'right',
  (theme: Theme) => SystemCssProperties<Theme>
> = {
  right: (theme) => ({
    justifyContent: 'flex-end',
    ...(theme.direction === 'rtl'
      ? gradients.horizontalListChevronLeft
      : gradients.horizontalListChevronRight),
  }),
  left: (theme) => ({
    justifyContent: 'flex-start',
    ...(theme.direction === 'rtl'
      ? gradients.horizontalListChevronRight
      : gradients.horizontalListChevronLeft),
  }),
};

const IconLookup = {
  left: 'ChevronLeft',
  right: 'ChevronRight',
} as const;

const SliderArrow = ({ direction, visibility, iconHeight, onClick }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={[
        {
          position: 'absolute',
          display: 'flex',
          height: '100%',
          left: direction === 'left' ? 0 : 'auto',
          right: direction === 'right' ? 0 : 'auto',
          visibility: visibility,
          top: 0,
          minWidth: 136,
          zIndex: 1,
        },
        DirectionStyles[direction],
      ]}
    >
      <IconButton
        disableFocusRipple
        disableRipple
        aria-label={direction === 'left' ? 'Previous slide' : 'Next slide'}
        variant="standard"
        sx={{
          transform: (theme) => `scaleX(${theme.direction === 'rtl' ? -1 : 1})`,
          alignItems: 'flex-start',
          '&& svg': {
            width: 40,
            height: 40,
          },
          p: 0,
        }}
      >
        <Icon
          name={IconLookup[direction]}
          sx={{
            transform: `translateY(${iconHeight}px)`,
            fontSize: CHEVRON_FONT_SIZE,
          }}
        />
      </IconButton>
    </Box>
  );
};

export default SliderArrow;
